import { useEffect, useState } from 'react';
import * as THREE from 'three';

// Loads a texture from /public if it exists, silently falling back to a
// provided (procedural) texture when it doesn't — so the town renders with
// canvas materials until the Gemini texture pack is generated, and upgrades
// itself the moment the PNGs land in public/textures/.

const loader = new THREE.TextureLoader();
const cache = new Map(); // url -> THREE.Texture | 'failed' | Promise

export function useOptionalTexture(url, fallback) {
  const [tex, setTex] = useState(() => {
    const hit = cache.get(url);
    return hit instanceof THREE.Texture ? hit : null;
  });

  useEffect(() => {
    const hit = cache.get(url);
    if (hit instanceof THREE.Texture) { setTex(hit); return; }
    if (hit === 'failed') return;

    let cancelled = false;
    loader.load(
      url,
      (t) => {
        t.colorSpace = THREE.SRGBColorSpace;
        t.wrapS = t.wrapT = THREE.RepeatWrapping;
        t.anisotropy = 8;
        cache.set(url, t);
        if (!cancelled) setTex(t);
      },
      undefined,
      () => cache.set(url, 'failed')
    );
    return () => { cancelled = true; };
  }, [url]);

  return tex || fallback;
}
